<template>
  <div>
    <div class="bidding-watermark" v-if="showWarning">
      <div>{{ $t("YouAreCurrentlyOnBiddingInstance") }}</div>
      <button @click="isOpen = true">x</button>
    </div>
    <v-dialog
      v-model="isOpen"
      max-width="790"
      width="530"
      :persistent="true"
      @keydown.prevent.enter="executeMainAction"
    >
      <v-card class="dialog-box">
        <v-card-title class="headline">
          {{ $t("DismissFor") }}
        </v-card-title>


        <v-card-actions>
          <v-btn
            @click="cancelDismiss"
            :ripple="false"
            class="secondary-button"
            text
          >
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn
            @click="dismiss(0.25)"
            :ripple="false"
            class="main-button"
            text
          >
            {{ $t("15min") }}
          </v-btn>
          <v-btn
            @click="dismiss(0.5)"
            :ripple="false"
            class="main-button"
            text
          >
            {{ $t("30min") }}
          </v-btn>
          <v-btn
            @click="dismiss(1)"
            :ripple="false"
            class="main-button"
            text
          >
            {{ $t("60min") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
export default {
  name: "BiddingWarning",
  data() {
    return {
      isOpen: false,
      showWarning: false,
      dismissingFor: null
    };
  },
  methods: {
    dismiss(interval) {
      sessionStorage.setItem(
        "bidding_next_warning",
        new Date((new Date).getTime() + (interval * 60 * 60000)));
      this.isOpen = false;
      this.showWarning = false;
    },
    cancelDismiss() {
      this.isOpen = false;
    },
    refreshWarning() {
      const next_warning = sessionStorage.getItem("bidding_next_warning");
      this.showWarning = next_warning === null || new Date(next_warning) < new Date();
    }
  },

  mounted() {
    this.refreshWarning();
    setInterval(this.refreshWarning, 60 * 1000);
  }
};
</script>


<style scoped>
.bidding-watermark {
  z-index: 999;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  background: #231e46;
  color: white;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding-left: 6px;
}

.bidding-watermark > div {
  flex: 1 1;
}

.bidding-watermark > button {
  padding: 0 6px;
}

.bidding-watermark > button:hover {
  background: #434070;
  border-top-right-radius: 3px;
}

</style>



// WEBPACK FOOTER //
// src/components/_Atoms/BiddingWarning.vue